<template>
  <div>
    <main class="styles-app-structure-main">
    <section class="styles-app-structure-section">

      <div class="styles-app-structure-program">
        <div class="styles-app-structure-main-content">
          <sportToolbar :autoRewrite="true" onlive="1" class="pb-3" />
          <template v-if="$route.query.favOnly || $route.params.sport || $route.params.event">
            <matches :filter="filter" v-if="refresh" hidePagination="true" :onLive="true" refs="matches"/>
            <upcomingWidget :list="1" v-if="upcoming" />
          </template>
        </div>
      </div>

      <matchDetail v-if="$route.params.event" />
    </section>

    <aside id="aside" class="styles-app-structure-aside">

      <div class="Aside-styles-aside-wrapper">
        <betSlip />
      </div>
      <LocaleSelection />
      <betPot />
      <topRewards />

    </aside>

    </main>

    <CountDownLoader />
  </div>
</template>

<script>

import nbaTv from '@/components/sportsbook/widget/nbaTv';
import liveCasinoBanner from '@/components/sportsbook/widget/liveCasinoBanner'
import upcomingToolbar from '@/components/sportsbook/upcomingToolbar'
import CompetitionSide from '@/components/sportsbook/CompetitionSide';
import matches from '@/components/sportsbook/matches';
import BetSlip from '@/components/sportsbook/BetSlip';
import odd from '@/components/sportsbook/odd';
import sportToolbar from '@/components/sportsbook/sportToolbar'
import playingWidget from '@/components/sportsbook/widget/playing'
import transfer from '@/components/transfer/form/transfer'
import LiveMatches from "@/components/sportsbook/LiveMatches"
import topRewards from '@/components/sportsbook/widget/topRewards';

import statsInfo from '@/components/sportsbook/widget/statsInfo'
import supportInfo from '@/components/sportsbook/widget/supportInfo';
import recommendedLinks from '@/components/sportsbook/widget/recommendedLinks'
import mobileInfo from '@/components/sportsbook/widget/mobileinfo'
import matchDetail from '@/components/sportsbook/matchDetail';
import betPot from '@/components/widget/betPot';
import CountDownLoader from '@/components/sportsbook/countdownLoader'
import upcomingWidget from '@/components/sportsbook/widget/upcoming';
import LocaleSelection from '../ui/localeSelection';

export default {
  name: 'SportsbookFixture',
  components: {upcomingWidget, CountDownLoader, betPot, matchDetail, topRewards, nbaTv, liveCasinoBanner, CompetitionSide, matches, BetSlip, odd, sportToolbar, playingWidget, transfer, LiveMatches,
    statsInfo,
    supportInfo,
    recommendedLinks,
    mobileInfo,
    upcomingToolbar,
    LocaleSelection
  },
  data() {
    return {
      r: this.$root,
      t: this.$root.t,
      live: 1,
      selectedMatch: {},
      viewport: 1,
      upcoming: false,
      query: {
        onLive: 1
      },
      events: null,
      xhr_request: [],
      refresh: true,
      filter: {loadmore: true, upcoming: '+24 hours', list: 1, sport: this.$route.params.sport, onLive: true, isLive: 0, per_page: 200}
    }
  },
  watch: {
    '$route.params.sport'(o, n) {
      this.refresh = false;
      this.filter.sport = this.$route.params.sport;

      setTimeout(() => {
        this.refresh = true;
      }, 500);
    },

  },
  beforeRouteLeave (to, from, next) {

    if(this.xhr_request){
      for (var i = 0; i < this.xhr_request.length; i++) {
        this.xhr_request.shift().abort();
      }
    }

    next();
  },
  destroyed() {
    //wss.unsubscribe("stream/odd");


  },
  mounted() {

    this.init()
    setTimeout(this.init, 500);

    setTimeout(() => {
      this.upcoming = true;
    }, 1500)

    window.scroll(0,0);

    var th = this;
    this.$bus.$on('FixtureEvents', ($event) => {

      if (!th.events)
        th.events = $event;

    });
  },
  methods: {
    changeViewPort(v) {
      this.viewport = v;
    },
    init() {
      if (this.$route.query.view) {
        this.viewport = this.$route.query.view;
      }

      var th = this;

      this.$bus.$on('selectedMatch', (payload) => {
        th.selectedMatch = payload;
      });
    },
    filterFx(e) {
      this.filter = e;
      console.log(e);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


/*@media (max-width: 1600px) {
    .match-event-block {
        width: 55% !important;
    }
    .betslip-block {
        width: 15% !important;
    }
    .competition-block {
        width: 21vw !important;
    }
}

@media (max-width: 1200px) {
    .match-event-block {
        width: 50vw !important;
    }
    .betslip-block {
        width: 24vw !important;
    }
    .competition-block {
        width: 24vw !important;
    }
}

@media (max-width: 1200px) {
    .match-event-block {
        width: 54% !important;
    }
    .betslip-block {
        width: 23% !important;
    }
    .competition-block {
        width: 22% !important;
    }
}

.betslip-block {
    width: 15%;
    float: left;
}

.competition-block {
    width: 19%;
    float: left;
    padding: 0 0 0 20px;
}

.match-event-block {
    width: 65%;
    float: left;
    padding: 0 35px 0 35px;
}*/

.os-tabs-controls {
  margin-bottom: 2rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.os-tabs-controls .nav-tabs {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.os-tabs-controls .nav-pills {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.sport-menu {
  font-size: 29px;
}

.nav-link.active i {
  color: #ef8107 !important
}

.nav-tabs .nav-link[data-v-f5ac4f5a]:after, .nav-tabs .nav-item .nav-link:after {
  background: #ef8207 !important;
}

.asideBox-block .nav {
  background: #003366;
  min-height: 52px;
  border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/live.vue